<template>
  <div class="project-infrastructure-map">
    <div class="project-infrastructure-map__map">
      <MapRoot />
    </div>
  </div>
</template>

<script>
import MapRoot from "@/components/home/MapRoot.vue";

export default {
  name: "ProjectInfrastructureMap",
  components: {
    MapRoot,
  },
  props: {},
  setup(props) {
    return {};
  },
};
</script>

<style scoped>
.project-infrastructure-map {
  position: relative;
  height: 500px;
}

@media (min-width: 768px) {
  .project-infrastructure-map {
    height: 75vh;
  }
}

@media (max-width: 767px) {
  .project-infrastructure-map {
    min-height: 330px;
  }
}

.project-infrastructure-map__map {
  overflow: hidden;
  width: 100%;
  height: 100%;
  border-radius: 12px;
  background-color: #f5f5f5;
}

@media (max-width: 1023px) {
  .project-infrastructure-map__map {
    display: flex;
    aspect-ratio: 0.57;
  }
}
</style>
